import { BrowserChrome } from "@/components/products/shared";

const MONO = "font-[family-name:var(--font-mono)]";

export function XeniIngestion() {
  return (
    <BrowserChrome height="h-[320px]">
      <div className={`h-full text-[10px] ${MONO} flex flex-col gap-3`}>
        {/* Upload area */}
        <div className="border border-dashed border-[var(--color-border)] px-3 py-2 text-center text-[var(--color-fg-tertiary)]">
          Document ingestion
        </div>

        {/* File list */}
        <div className="space-y-1.5">
          <div className="flex items-center justify-between px-2 py-1.5 border border-[var(--color-border)]">
            <span className="text-[var(--color-fg-secondary)]">passport_chen.pdf</span>
            <span className="text-emerald-500">&#10003;</span>
          </div>
          <div className="flex items-center justify-between px-2 py-1.5 border border-[var(--color-border)]">
            <span className="text-[var(--color-fg-secondary)]">employment_letter.pdf</span>
            <span className="text-emerald-500">&#10003;</span>
          </div>
          <div className="flex items-center justify-between px-2 py-1.5 border border-[var(--color-border)]">
            <span className="text-[var(--color-fg-secondary)]">bank_statements.pdf</span>
            <span className="w-2 h-2 rounded-full bg-amber-500 animate-pulse" />
          </div>
        </div>

        {/* Extracted data */}
        <div className="mt-auto border-t border-[var(--color-border)] pt-3 space-y-1 text-[var(--color-fg-secondary)]">
          <div className="text-[var(--color-fg-tertiary)] text-[9px] mb-1.5">Extracted fields</div>
          <div>Full name: <span className="text-[var(--color-fg)]">Sarah Chen</span></div>
          <div>Passport: <span className="text-[var(--color-fg)]">582730194</span></div>
          <div>Employer: <span className="text-[var(--color-fg)]">TechCorp Ltd</span></div>
        </div>
      </div>
    </BrowserChrome>
  );
}

export function XeniFormFill() {
  const fields = [
    { label: "Full name", value: "Sarah Chen" },
    { label: "Passport", value: "582730194" },
    { label: "Nationality", value: "Malaysian" },
  ];

  return (
    <BrowserChrome height="h-[320px]">
      <div className={`h-full text-[10px] ${MONO} flex flex-col`}>
        {/* Form fields */}
        <div className="space-y-3">
          {fields.map((f) => (
            <div key={f.label}>
              <div className="text-[var(--color-fg-tertiary)] mb-1">{f.label}</div>
              <div
                className="h-7 border px-2 flex items-center text-[var(--color-fg-secondary)]"
                style={{
                  borderColor: "rgb(16 185 129 / 0.3)",
                  background: "rgb(16 185 129 / 0.05)",
                }}
              >
                {f.value}
              </div>
            </div>
          ))}
        </div>

        {/* Validation checklist */}
        <div className="mt-auto border-t border-[var(--color-border)] pt-3 space-y-1">
          <div className="text-[var(--color-fg-tertiary)] text-[9px] mb-1.5">Validation</div>
          <div className="text-emerald-500">&#10003; Identity verified</div>
          <div className="text-emerald-500">&#10003; Employment confirmed</div>
          <div className="text-emerald-500">&#10003; Financial threshold met</div>
          <div className="text-amber-500">&#9888; Employment gap detected</div>
        </div>
      </div>
    </BrowserChrome>
  );
}

export function XeniReview() {
  const trail = [
    { action: "Form generated", time: "14:23" },
    { action: "Evidence cross-checked", time: "14:24" },
    { action: "QA approved", time: "14:31" },
    { action: "Submitted to UKVI", time: "14:32" },
  ];

  return (
    <BrowserChrome height="h-[320px]">
      <div className={`h-full text-[10px] ${MONO} flex flex-col`}>
        {/* Header with badge */}
        <div className="flex items-center justify-between mb-4">
          <span className="text-[var(--color-fg-tertiary)] text-[9px]">Application review</span>
          <span className="text-[8px] px-1.5 py-0.5 rounded bg-emerald-500/20 text-emerald-500">
            Submitted
          </span>
        </div>

        {/* Reviewed by */}
        <div className="flex items-center gap-2 mb-5 pb-3 border-b border-[var(--color-border)]">
          <span className="w-5 h-5 rounded-full bg-[var(--color-surface)] border border-[var(--color-border)] flex-shrink-0" />
          <div>
            <div className="text-[var(--color-fg)]">Senior Immigration Lawyer</div>
            <div className="text-[var(--color-fg-tertiary)] text-[9px]">Reviewed by</div>
          </div>
        </div>

        {/* Audit trail */}
        <div className="space-y-0">
          <div className="text-[var(--color-fg-tertiary)] text-[9px] mb-2">Audit trail</div>
          {trail.map((entry) => (
            <div
              key={entry.action}
              className="flex items-center justify-between py-1.5 border-b border-[var(--color-border)] last:border-b-0"
            >
              <div className="flex items-center gap-2">
                <span className="w-1 h-1 rounded-full bg-emerald-500 flex-shrink-0" />
                <span className="text-[var(--color-fg-secondary)]">{entry.action}</span>
              </div>
              <span className="text-[var(--color-fg-tertiary)]">{entry.time}</span>
            </div>
          ))}
        </div>
      </div>
    </BrowserChrome>
  );
}
